import { AutocompleteConfig } from '@ntv360/component-pantry';
import { TableColumn, TableToolbarButton } from '@shared';
import { COLORS } from '@shared/constants';

/**
 * Media stats constants that contains icon customized colors
 */
export const USERS_STATS_CUSTOM_COLORS: Record<string, { iconColor: string; bgColor: string }> = {
    totalUsers: {
        iconColor: '#0C2D0A',
        bgColor: '#E3FAE1',
    },
    superAdmins: {
        iconColor: '#8E0064',
        bgColor: '#FFF4FC',
    },
    dealerAdmins: {
        iconColor: '#FFA500',
        bgColor: '#FFF2DB',
    },
    dealers: {
        iconColor: '#095AF3',
        bgColor: '#EEF4FE',
    },
};

/**
 * Users stats color class
 */
export const USERS_STATS_COLOR_CLASS: Record<string, string> = {
    totalUsers: 'text-green-600',
    superAdmins: 'text-green-600',
    dealerAdmins: 'text-green-600',
    dealers: 'text-green-600',
};

/**
 * Users page controls right side buttons
 */
export const USERS_CONTROLS_BUTTONS: TableToolbarButton[] = [
    {
        buttonName: 'Bulk Delete',
        icon: 'outline-trash',
        variant: 'danger',
        disabled: true,
    },
    {
        buttonName: 'Export',
        icon: 'export',
        variant: 'accent',
        disabled: false,
    },
];

/**
 * Users table columns layout
 */
export const USERS_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'name',
        header: 'Name',
        width: '320px',
        hasRedirect: true,
        filterType: 'text',
        /** 0 = no character cap; cell uses column width + CSS ellipsis (`truncate` on table cell). */
        truncateLimit: 0,
    },
    {
        field: 'emailAddress',
        header: 'Email Address',
        width: '400px',
        filterType: 'text',
        truncateLimit: 0,
    },
    { field: 'role', header: 'Role', width: '150px' },
    { field: 'createdAt', header: 'Creation Date', width: '150px' },
    { field: 'createdBy', header: 'Created By', width: '150px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '100px',
        type: 'actions',
        actions: [
            {
                icon: 'outline-trash',
                name: 'Delete',
                size: 13,
                color: COLORS.danger,
                hightlighLabel: true,
            },
        ],
    },
];

/**
 * Filter Autocomplete configurations
 */
export const USERS_FILTER_AUTOCOMPLETE_CONFIG: AutocompleteConfig = {
    searchable: false,
    multiple: false,
    checkbox: true,
    placeholder: 'Timezone',
};

/**
 * User activity table columns layout
 */
export const USER_ACTIVITY_TABLE_COLUMNS: TableColumn[] = [
    { field: 'activityTarget', header: 'Activity Target', width: '80px' },
    { field: 'activityDescription', header: 'Activity Description', width: '300px' },
    { field: 'createdAt', header: 'Creation Date', width: '100px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '80px',
        type: 'actions',
        actions: [
            {
                icon: 'eye',
                name: 'View',
                size: 14,
                color: COLORS.primary,
            },
        ],
    },
];
